//=====================================================
//　パスワードテキストボックス
//=====================================================
import { FieldValues, useFormContext, UseFormReturn } from "react-hook-form";
import { InputTag } from '../utils/ConstCommon';
import { getMsg, ConstMsg } from '../utils/ConstMsg';
import { InputPasswordBase } from './InputPasswordBase';
import { LblInput } from './LblInput';
import { ValidErrMsgInline } from './ValidErrMsgInline';

const FORM_TITLE = 'パスワード';
const FORM_TITLE2 = 'パスワード（確認）';
const NAME = "login-password";
const NAME_CONFIRM = "login-password-confirm";

export function TxtChangePassword() {
    
    const cf = useFormContext();

    //バリデーション
    const validations = {
        required: getMsg(ConstMsg.EG0080001, [FORM_TITLE]),
        pattern: {value: /^[0-9a-zA-Z-]+$/, message: getMsg(ConstMsg.EG0080002, [FORM_TITLE])},
        maxLength: {value: 256, message: getMsg(ConstMsg.EG0080004, [FORM_TITLE, '256'])},
        validate: {sameCheck: function(){return sameCheck(cf)}}
    }

    //-----------------------------------------------------
    //　パスワードとパスワード（確認）の一致チェック
    //-----------------------------------------------------
    function sameCheck(cf: UseFormReturn<FieldValues>){
        //パスワードとパスワード（確認）が一致しない場合エラー
        if (cf.getValues(NAME) !== cf.getValues(NAME_CONFIRM)){
            return ConstMsg.EG0210001;
        }
        return null;
    }

    return (
        <>
            <div className="patient-data input-box">
                <LblInput title={FORM_TITLE} tag={InputTag.Required} />
                <ValidErrMsgInline name={NAME}/>
                <div className='input-login-password'>
                    <InputPasswordBase name={NAME} className='input-text-login-password' validations={validations}/>
                </div>
                <div className="input-supple">
                    <div>※半角英数字のみ</div>
                    <div>パスワードは必須項目です。変更しない場合は、現在のパスワードを入力してください。</div>
                </div>
            </div>
            <div className="patient-data input-box">
                <LblInput title={FORM_TITLE2} tag={InputTag.Required} />
                <ValidErrMsgInline name={NAME_CONFIRM}/>
                <div className="input-login-password">
                    <InputPasswordBase name={NAME_CONFIRM} className='input-text-login-password' validations={validations}/>
                </div>
                <div className="input-supple">
                    <div>※確認のため、再度パスワードを入力してください</div>
                </div>
            </div>
        </>
       
    )

}

